import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ServiceOneImg from '@/assets/images/registration.jpg'
import ServiceTwoImg from '@/assets/images/pillar-investment.jpg'
import ServiceThreeImg from '@/assets/images/pillar-business.jpg'
import ServiceFourImg from '@/assets/images/tender.jpg'

const getPillars = (t: (key: string) => string) => [
  {
    img: ServiceOneImg,
    title: t("pillar1Title"),
    desc: t("pillar1Desc"),
    link: "/services",
    number: "01",
  },
  {
    img: ServiceTwoImg,
    title: t("pillar2Title"),
    desc: t("pillar2Desc"),
    link: "/services",
    number: "02",
  },
  {
    img: ServiceThreeImg,
    title: t("pillar3Title"),
    desc: t("pillar3Desc"),
    link: "/business",
    number: "03",
  },
  {
    img: ServiceFourImg,
    title: t("pillar4Title"),
    desc: t("pillar4Desc"),
    link: "/tenders",
    number: "04",
  },
];

export default function WhatWeDo() {
  const { t } = useTranslation();
  const pillars = getPillars(t);

  return (
    <section className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-16">
        <div className="mb-20">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#E6FAFA] mb-4">
                <div className="w-2 h-2 rounded-full bg-[#00C2C2]" />
                <span className="text-xs font-bold text-[#00C2C2] uppercase tracking-wider">
                  {t("whatWeDoTag")}
                </span>
              </div>
              <h2 className="text-4xl lg:text-5xl font-extrabold text-[#0A1628] leading-tight">
                {t("whatWeDoTitle")} <span className="text-[#00C2C2]">{t("whatWeDoTitleAccent")}</span>
              </h2>
            </div>
            <p className="text-gray-500 max-w-sm text-sm leading-relaxed">
              {t("whatWeDoDesc")}
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {pillars.map((p) => (
              <Link
                key={p.title}
                to={p.link}
                className="group bg-white border border-gray-100 rounded-2xl overflow-hidden cursor-pointer hover:border-[#00C2C2]/30 hover:-translate-y-1 transition-all duration-300"
              >
                {/* Image area */}
                <div className="relative overflow-hidden h-52">
                  <img
                    src={p.img}
                    alt={p.title}
                    loading="lazy"
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  {/* Dark gradient overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628]/75 via-[#0A1628]/20 to-transparent" />

                  {/* Number badge */}
                  <span className="absolute top-4 left-4 text-4xl font-black text-white/20 leading-none select-none z-10">
                    {p.number}
                  </span>

                  {/* Arrow button */}
                  <div className="absolute bottom-4 right-4 z-10 w-9 h-9 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm border border-white/25 text-white transition-all duration-300 group-hover:bg-[#00C2C2] group-hover:border-[#00C2C2]">
                    <i className="ri-arrow-right-up-line text-sm" />
                  </div>
                </div>

                {/* Text content */}
                <div className="p-6">
                  <h3 className="text-base font-bold text-[#0A1628] mb-2 group-hover:text-[#00C2C2] transition-colors leading-snug">
                    {p.title}
                  </h3>
                  <p className="text-gray-500 text-sm leading-relaxed">
                    {p.desc}
                  </p>
                  <div className="flex items-center gap-1 text-[#00C2C2] group-hover:text-[#00AAAA] text-sm font-semibold transition-colors mt-4">
                    {t("learnMore")} <i className="ri-arrow-right-line" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}